import type {
  EntityHistoryActionPayload,
  EntityHistoryReducerState
} from '../entityHistory.types';
import { EntityHistoryActionTypesEnum } from '../entityHistory.types';

const entityHistoryReducer = (
  state: EntityHistoryReducerState,
  action: EntityHistoryActionPayload
): EntityHistoryReducerState => {
  switch (action.type) {
    case EntityHistoryActionTypesEnum.updateEntityHistory:
      return {
        ...state,
        enitityData: {
          ...state.enitityData,
          [action.payload.entityId]: action.payload.data
        }
      };

    case EntityHistoryActionTypesEnum.replaceAll:
      return action.payload;

    default:
      return state;
  }
};

export default entityHistoryReducer;
